import React, { Component } from 'react';

import SuccessAlert from './SuccessAlert';
import InputForm from './InputForm';
import Authors from './Authors';

import fire from '../fire';
import 'firebase/firestore';
import kinopoisk from '../config/kinopoisk';
import { Tab, Tabs } from '@material-ui/core';

class MainComponent extends Component {
  constructor(props) {
    super(props);
    this.inputForm = React.createRef();
    this.state = {
      authors: [],
      tabValue: 0,
      showSuccessAlert: false
    };

    this.db = fire.firestore();
    this.db.settings({
      timestampsInSnapshots: true
    });

    this.canAddAuthorWithUrl = this.canAddAuthorWithUrl.bind(this);
  }

  componentDidMount = () => {
    this.loadDb();
  };

  //////////////////////
  // firebase-db-methods
  //////////////////////

  loadDb = () => {
    this.db
      .collection('authors')
      .orderBy('nickname')
      .get()
      .then(collection => {
        const authors = collection.docs.map(doc => doc.data());
        this.setState({ authors });
      });

    this.db
      .collection('authors')
      .orderBy('nickname')
      .onSnapshot(this.onCollectionUpdate);
  };

  onCollectionUpdate = querySnapshot => {
    const authors = [];
    querySnapshot.forEach(doc => {
      const author = doc.data();
      authors.push(author);
    });
    this.setState({ authors });
  };

  addAuthorToDb = (nickname, url) => {
    this.setState({ isProcessing: true });

    const kpid = this.getId(url);
    const author = { nickname, kpid };

    this.db
      .collection('authors')
      .add(author)
      .then(() => {
        this.setState({ isProcessing: false });
        this.onAuthorAdd();
      });
  };

  onAuthorAdd = () => {
    this.setState({ showSuccessAlert: true });
    setTimeout(() => {
      this.setState({ showSuccessAlert: false });
    }, 1000);
  };

  //////////////////////
  // heplers
  //////////////////////

  getId = authorUrl => {
    const pattern = kinopoisk.authorUrlPattern;
    let strId = authorUrl.match(pattern)[1];
    return parseInt(strId, 10);
  };

  authorWithUrlExists = url =>
    this.state.authors.some(author => author.kpid === this.getId(url));

  authorWithNicknameExists = nickname =>
    this.state.authors.some(author => author.nickname === nickname);

  canAddAuthorWithUrl = url =>
    this.isValidAuthorUrl(url) && !this.authorExists(url);

  authorsFetched = () =>
    Array.isArray(this.state.authors) && this.state.authors.length;

  authorsCountStr = () =>
    this.authorsFetched() ? ` (${this.state.authors.length})` : '    ';

  handleTabChange = (event, value) => {
    this.setState({ tabValue: value });
  };

  renderTabContent = tabValue => {
    if (tabValue === 0) {
      return (
        <InputForm
          addAuthor={this.addAuthorToDb}
          authorWithUrlExists={this.authorWithUrlExists}
          authorWithNicknameExists={this.authorWithNicknameExists}
          authorsCount={this.state.authors.length}
          ref={this.inputForm}
        />
      );
    }
    if (tabValue === 1) {
      return <Authors authors={this.state.authors} />;
    }
  };

  render() {
    const { tabValue } = this.state;
    return (
      <main>
        <SuccessAlert show={this.state.showSuccessAlert} />
        <Tabs
          value={tabValue}
          onChange={this.handleTabChange}
          indicatorColor="primary"
          centered
        >
          <Tab label="Добавить автора" />
          <Tab label={'Список авторов' + this.authorsCountStr()} />
        </Tabs>

        <div className="flex-container">{this.renderTabContent(tabValue)} </div>
      </main>
    );
  }
}

export default MainComponent;



// WEBPACK FOOTER //
// ./src/components/MainComponent.jsx